export const createTicketsTestSelectors = {
  page: 'create-tickets-page',
  searchBar: {
    input: 'create-tickets-advanced-search-bar',
    searchButton: 'create-tickets-search-button'
  },
  lightweightPathwaysContainer: 'create-tickets-lightweight-pathways-container',
  saveButton: 'create-tickets-submit-button'
};
